var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProjectLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29907_13929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0866 9.33333C11.9262 9.33333 11.0033 10.2563 11.0033 11.4167V28.75C11.0033 29.9104 11.9262 30.8333 13.0866 30.8333H27.0866C28.247 30.8333 29.1699 29.9104 29.1699 28.75V15.463L23.0402 9.33333H13.0866ZM9.16992 11.4167C9.16992 9.24374 10.9137 7.5 13.0866 7.5H23.4199C23.663 7.5 23.8962 7.59658 24.0681 7.76849L30.7348 14.4352C30.9067 14.6071 31.0033 14.8402 31.0033 15.0833V28.75C31.0033 30.9229 29.2595 32.6667 27.0866 32.6667H13.0866C10.9137 32.6667 9.16992 30.9229 9.16992 28.75V11.4167Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0688 7.5698C23.4113 7.42792 23.8056 7.50635 24.0678 7.76851L30.7344 14.4352C30.9966 14.6973 31.075 15.0916 30.9332 15.4342C30.7913 15.7767 30.457 16 30.0863 16H24.4196C23.33 16 22.5029 15.173 22.5029 14.0834V8.41669C22.5029 8.04594 22.7263 7.71169 23.0688 7.5698ZM24.3363 10.6297V14.0834C24.3363 14.1195 24.3425 14.1393 24.3455 14.1468C24.3472 14.1509 24.3484 14.153 24.3491 14.1539C24.3499 14.1545 24.3521 14.1558 24.3561 14.1574C24.3637 14.1604 24.3835 14.1667 24.4196 14.1667H27.8732L24.3363 10.6297Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.084 21.0013H15.084V19.168H25.084V21.0013Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.084 26.8353H15.084V25.002H25.084V26.8353Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29907_13929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8333,
    height: 25.1667,
    fill: "white",
    transform: "translate(9.16699 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectLight);
export default __webpack_public_path__ + "static/media/icon_project_light.386976d4.svg";
export { ForwardRef as ReactComponent };